define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/query",
	"dijit/form/ToggleButton",
	"dijit/registry"
], function(declare,domClass,query,ToggleButton,registry) {

	return declare(ToggleButton, {
		// String: class to use as radio group
		radioClass: null,

		postCreate: function() {
			domClass.add(this.domNode, this.radioClass);
			this.inherited(arguments);
		},

		_setCheckedAttr: function(/*Boolean*/value) {
			// summary: when checked, uncheck other widgets in radio group
			this.inherited(arguments);

			if (value) {
				var	node = this.domNode;
				var	w = registry.getEnclosingWidget(node.parentNode);

				query("." + this.radioClass, w.domNode).forEach(function(n) {
					if (n != node) {
						registry.byNode(n).set("checked", false);
					}
				});
			}
		}
	});
});